export const ExperimentNames = {
    UseWarmupData: 'specs.events.ui.UseWarmupData',
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    DisableMembersSiteCreation: 'specs.events.ui.DisableMembersSiteCreation',
    SelectEventsManually: 'specs.events.ui.SelectEventsManually',
    ReservationWithoutWixFeeEnabled: 'specs.events.ReservationWithoutWixFeeEnabled',
    viewerNoCss: 'specs.events.ui.viewerNoCss',
    CancelReservationInDetailsPage: 'specs.events.ui.CancelReservationInDetailsPage',
    DashboardRedesign: 'specs.events.ui.DashboardRedesign',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    ShowExpiredScreenIncorrectSlug: 'specs.events.ui.showExpiredScreenIncorrectSlug',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    NewSeatingTemplates: 'specs.events.ui.NewSeatingTemplates',
    NewDashboardReleaseModal: 'specs.events.ui.NewDashboardReleaseModal',
    FixNavigateToPage: 'specs.events.ui.FixNavigateToPage',
    NewMobileWidgetLayouts: 'specs.events.ui.NewMobileWidgetLayouts',
    NewMobileWidgetSettings: 'specs.events.ui.NewMobileWidgetSettings',
    PublishedListTips: 'specs.events.PublishedListTips',
};
//# sourceMappingURL=experiments.js.map